/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_BOUNDING_BOX = gql`
  mutation UpdateBoundingBox($boxId: ID!, $metaClass: MetaClass!, $tagId: ID) {
    updateBoundingBox(boxId: $boxId, metaClass: $metaClass, tagId: $tagId) {
      __typename
      ... on UpdateBoundingBoxResult {
        boundingBox {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          tagId
          tag
          isHumanAdded
          isHumanDeleted
          leasedById
          leasedAt
        }
        undoAction {
          mutationName
          variablesPayload
        }
        redoAction {
          mutationName
          variablesPayload
        }
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
